import { FormNotifications, CurrentUser, LocationData } from 'types';

export const getLocationStep = (
  user: CurrentUser,
  notifications: Record<string, FormNotifications>,
  onPass: (data: LocationData) => void,
) => ({
  stepName: 'Location',
  onPass: async (data: LocationData) => {
    onPass(data);
  },
  formProps: {
    buttonCaption: 'Continue',
    notifications: notifications,
    fields: [
      {
        type: 'notification',
        fieldName: 'signUpStep3',
      },
      {
        type: 'title',
        fieldName: 'title',
        value: 'Where in the world are you?',
      },
      {
        type: 'description',
        fieldName: 'value',
        value: 'This will help us display the hottest items available near you.',
      },
      {
        type: 'locationBlock',
        user: user,
      },
    ],
  },
});
